module.exports = __webpack_public_path__ + "img/bell.763a9e08.png";